import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from "vuex";
import { saveAutoReplyMsg } from "@/api/customerCenter/customerCenter";
export default {
  data: function data() {
    return {
      paramsData: {
        id: '',
        auto_msg: "",
        game: '',
        is_auto_reply: true
      },
      dialogShow: false,
      gameAllList: [],
      rules: {
        game: [{
          required: true,
          message: "请选择游戏",
          trigger: "blur"
        }],
        auto_msg: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        is_auto_reply: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    getGameData: function getGameData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("d2admin/game/GameList");

              case 2:
                query = _context.sent;
                _this.gameAllList = query || [];

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    open: function open(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var d;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (data) {
                  d = JSON.parse(JSON.stringify(data));
                  console.log(" Object.keys(paramsData)==", Object.keys(_this2.paramsData));
                  Object.keys(_this2.paramsData).forEach(function (item) {
                    _this2.paramsData[item] = d[item];
                  });
                }

                _this2.dialogShow = true;

                _this2.getGameData();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: '',
        auto_msg: '',
        game: '',
        is_auto_reply: true
      };
      this.$refs.ruleForm.clearValidate();
      this.dialogShow = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          saveAutoReplyMsg(_this3.paramsData).then(function (res) {
            if (res.code == 200) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.clearData();

              _this3.$emit('refreshDataList');
            }
          });
        }
      });
    }
  }
};